import { render, staticRenderFns } from "./ServiceProvideMsg.vue?vue&type=template&id=9edd7b66&"
import script from "./ServiceProvideMsg.vue?vue&type=script&lang=js&"
export * from "./ServiceProvideMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports